export default __webpack_public_path__ + "static/media/element_spec_2.921e7ad3.webp";